import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function PortalHelp() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Portal (Help)? </h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Portal (Help)?</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="col-12">
                        <h1>Portal (Help)?</h1>
                        <br/>
                        <h2 className="subhead">
                            <b>CampusCare® Application Guidelines &amp; Instructions </b>
                        </h2>
                        <p className="guideheading">
                            <strong>How to LOG IN Parent Portal?</strong>
                        </p>
                        <p className="details">
                            1. Open Chrome
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/google.png"
                                alt="School ERP Software, Mobile App, School Management Software"
                            />{" "}
                            OR Mozilla{" "}
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/mzilla.png"
                                alt="School ERP Software, Mobile App, School Management Software"
                                className="lazyload"
                                data-sizes="auto"
                                data-threshold="1"
                                data-expand="10"
                            />{" "}
                            or Internet{" "}
                            <img
                                alt="School ERP Software, Mobile App, School Management Software"
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/internet.png"
                                className="lazyload"
                                data-sizes="auto"
                                data-threshold="1"
                                data-expand="10"
                            />{" "}
                        </p>
                        <p className="details">
                            2. Write the school URL{" "}
                            <strong>
                                <a target="_blank" href="http://www.smnscampuscare.in/" rel="noopener noreferrer">
                                    "smnscampuscare.in"
                                </a>
                            </strong>{" "}
                            in address bar. (you will be routed to the Log In credential page).
                        </p>
                        <p className="details">
                            3. Then, enter the USER ID and Click on "Next button", Then enter PASSWORD and Click on Sign in
                            button.
                        </p>
                        <p className="details">
                            Once logged in, you are welcomed with various information relating to assignments, news,
                            circulars, date sheet, fee details etc. that are self explanatory. Wish you to go through every
                            links that are provided and explore more.
                        </p>
                        <div className="clr10"></div>
                        <p className="guideheading">
                            <strong>How to RESET PASSWORD in Parent Portal? </strong>
                        </p>
                        <p className="details">
                            1. Open Chrome{" "}
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/google.png"
                                alt="School ERP Software, Mobile App, School Management Software"
                            />{" "}
                            OR Mozilla{" "}
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/mzilla.png"
                                alt="School ERP Software, Mobile App, School Management Software"
                                className="lazyload"
                                data-sizes="auto"
                                data-threshold="1"
                                data-expand="10"
                            />{" "}
                            or Internet{" "}
                            <img
                                alt="School ERP Software, Mobile App, School Management Software"
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/internet.png"
                                className="lazyload"
                                data-sizes="auto"
                                data-threshold="1"
                                data-expand="10"
                            />{" "}
                        </p>
                        <p className="details">
                            2. Write the school URL{" "}
                            <strong>
                                <a target="_blank" href="http://www.smnscampuscare.in/" rel="noopener noreferrer">
                                    "smnscampuscare.in"
                                </a>
                            </strong>{" "}
                            in address bar. (you will be routed to the Log In credential page).
                        </p>
                        <p className="details">3. Then, click on “Forgot User ID or Password?” text given below User ID field.</p>
                        <p className="details">
                            4. Select the User Type (For which you want a password) then Enter Registered Mobile No. and click on “Reset” Button.
                        </p>
                        <p className="details">5. You will get an SMS on your registered mobile no. along with login credentials. </p>
                        <div className="clr10"></div>
                        <div>
                            <p className="guideheading">
                                <strong> How to Install &amp; operate MOBILE APP? </strong>
                            </p>
                            <p>
                                1. Go to{" "}
                                <img
                                    alt="School ERP Software, Mobile App, School Management Software"
                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/playstore.png"
                                />{" "}
                                Store /{" "}
                                <img
                                    alt="School ERP Software, Mobile App, School Management Software"
                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/apple.png"
                                />{" "}
                                and Search "CampusCare®".
                            </p>
                            <p className="details">
                                2. Install and open the{" "}
                                <a href="https://www.entab.in/mobile-apps.html">
                                    <b>Mobile App</b>
                                </a>
                                .
                            </p>
                            <p className="details">
                                3. Enter school web portal URL:{" "}
                                <strong>
                                    <a target="_blank" href="http://www.smnscampuscare.in/" rel="noopener noreferrer">
                                        "smnscampuscare.in"
                                    </a>
                                </strong>{" "}
                                in link bar &amp; verify.
                            </p>
                            <p>4. After verifying, you will get an option for User ID &amp; Password.</p>
                            <p>
                                Once logged in, you are welcomed with various information relating to assignments, news.
                                circulars, date sheet, fee details etc that are self Explanatory. Wish you to go through every
                                links that are provided and explore more.
                            </p>
                            <p className="details">
                                <strong>NOTE* :</strong> Kindly update your{" "}
                                <a href="https://www.entab.in/mobile-apps.html">
                                    <b>Mobile Apps</b>
                                </a>{" "}
                                time to time to avoid difficulties during usage.
                            </p>
                        </div>
                        <div className="clr10"></div>
                        <div className="assistance">
                            <h5 className="guideheading">Please call or write for assistance:</h5>
                            <p className="details">
                                <strong>
                                    <a href="https://www.entab.in/contact-us.html">PARENT HELP DESK</a>
                                </strong>{" "}
                                ( 8 AM to 8:00 PM ) - <strong>Tele No.</strong> 011- 43193333-Ext : 5,
                                <strong>
                                    {" "}
                                    E-Mail :{" "}
                                    <a href="mailto:parentdesk@entab.in" className="yellow-link">
                                        parentdesk@entab.in
                                    </a>
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}
export default PortalHelp